import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { WithClassName } from '~/types/utils'
import { copyToClipboard } from '~/utils/string'
import Button from './Button'

type CopyButtonProps = WithClassName & {
  contentText: string
  disabled?: boolean
  onCopy?: () => unknown
  trackingLabel: TrackingLabel
}

const BaseCopyButton: FunctionComponent<CopyButtonProps> = ({ trackingLabel, contentText, disabled, onCopy }) => {
  const onClickCopy = (scopeId: string) => {
    copyToClipboard(scopeId)
  }

  return (
    <Button
      variant={'secondary'}
      iconName={'copy'}
      disabled={disabled}
      onClick={() => {
        onClickCopy(contentText)
        onCopy && onCopy()
      }}
      trackingLabel={trackingLabel}
    />
  )
}

export const CopyButton = styled(BaseCopyButton)``
